import React from 'react';
import { useModal } from '@/hooks/useModal';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const UpgradeSubscriptionModal = () => {
  const { closeModal } = useModal();
  
  return (
    <Dialog open={true} onOpenChange={() => closeModal()}>
      <DialogContent className="bg-slate-900/80 backdrop-blur-xl shadow-2xl text-white rounded-xl overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/20 to-purple-600/10 pointer-events-none" />
        
        <DialogHeader className="relative z-10">
          <DialogTitle className="text-2xl font-light text-center text-white/90">Upgrade Your Subscription</DialogTitle>
        </DialogHeader>
        
        <div className="py-8 text-center relative z-10">
          <p className="mb-8 text-lg text-white/80 px-4">
            Upgrade to Creator or Pro to unlock JSON export functionality.
          </p>
          
          <button 
            className="bg-indigo-600/90 hover:bg-indigo-700/90 focus:ring-2 focus:ring-indigo-400/50 transition-all duration-200 text-white px-8 py-3 rounded-lg shadow-lg backdrop-blur-sm"
            onClick={() => {
              window.location.href = '/checkout';
              closeModal();
            }}
          >
            View Plans
          </button>
        </div>
        
        <button 
          onClick={() => closeModal()}
          className="absolute top-3 right-3 text-white/70 hover:text-white transition-colors p-1 rounded-full"
          aria-label="Close dialog"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </DialogContent>
    </Dialog>
  );
};

// Add more modal components as needed
const SettingsModal = () => {
  const { closeModal } = useModal();
  
  return (
    <Dialog open={true} onOpenChange={() => closeModal()}>
      <DialogContent className="bg-slate-900/80 backdrop-blur-xl shadow-2xl text-white rounded-xl overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/20 to-purple-600/10 pointer-events-none" />
        
        <DialogHeader className="relative z-10">
          <DialogTitle className="text-2xl font-light text-center text-white/90">Settings</DialogTitle>
        </DialogHeader>
        
        <div className="py-6 relative z-10">
          <p>Settings content goes here...</p>
        </div>
        
        <button 
          onClick={() => closeModal()}
          className="absolute top-3 right-3 text-white/70 hover:text-white transition-colors p-1 rounded-full"
          aria-label="Close dialog"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </DialogContent>
    </Dialog>
  );
};

const FeedbackModal = () => {
  const { closeModal } = useModal();
  
  return (
    <Dialog open={true} onOpenChange={() => closeModal()}>
      <DialogContent className="bg-slate-900/80 backdrop-blur-xl shadow-2xl text-white rounded-xl overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/20 to-purple-600/10 pointer-events-none" />
        
        <DialogHeader className="relative z-10">
          <DialogTitle className="text-2xl font-light text-center text-white/90">Send Feedback</DialogTitle>
        </DialogHeader>
        
        <div className="py-6 relative z-10">
          <p>Feedback form goes here...</p>
        </div>
        
        <button 
          onClick={() => closeModal()}
          className="absolute top-3 right-3 text-white/70 hover:text-white transition-colors p-1 rounded-full"
          aria-label="Close dialog"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </DialogContent>
    </Dialog>
  );
};

const HelpModal = () => {
  const { closeModal } = useModal();
  
  return (
    <Dialog open={true} onOpenChange={() => closeModal()}>
      <DialogContent className="bg-slate-900/80 backdrop-blur-xl shadow-2xl text-white rounded-xl overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/20 to-purple-600/10 pointer-events-none" />
        
        <DialogHeader className="relative z-10">
          <DialogTitle className="text-2xl font-light text-center text-white/90">Help Center</DialogTitle>
        </DialogHeader>
        
        <div className="py-6 relative z-10">
          <p>Help content goes here...</p>
        </div>
        
        <button 
          onClick={() => closeModal()}
          className="absolute top-3 right-3 text-white/70 hover:text-white transition-colors p-1 rounded-full"
          aria-label="Close dialog"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </DialogContent>
    </Dialog>
  );
};

export const ModalProvider = () => {
  const { isOpen, modalType } = useModal();
  
  if (!isOpen || !modalType) return null;
  
  const modalComponents = {
    UPGRADE_SUBSCRIPTION: UpgradeSubscriptionModal,
    SETTINGS: SettingsModal,
    FEEDBACK: FeedbackModal,
    HELP: HelpModal
  };
  
  const ModalComponent = modalComponents[modalType];
  
  return ModalComponent ? <ModalComponent /> : null;
};

export default ModalProvider; 